/* eslint-disable import/no-anonymous-default-export */
import { lazy } from "react";
import Loadable from "../../components/layout/Loadable";

const Mentor = Loadable(lazy(() => import("../../pages/admin/users/user/Mentor")));

const FooterSetting = Loadable(
  lazy(() => import("../../pages/admin/setting/footerSetting/FooterSetting")),
);
const BannerSliderSetting = Loadable(
  lazy(() => import("../../pages/admin/setting/bannerSlider/BannerSliderSetting")),
);



const Blogs = Loadable(lazy(() => import("../../pages/admin/master/bolgs")));
const AddBlogs = Loadable(
  lazy(() => import("../../pages/admin/master/bolgs/AddBlogs")),
);
const EditBlogs = Loadable(
  lazy(() => import("../../pages/admin/master/bolgs/EditBlogs")),
);
const ReorderBlogs = Loadable(
  lazy(() => import("../../pages/admin/master/bolgs/ReorderBlogs")),
);

const BlogsImage = Loadable(
  lazy(() => import("../../pages/admin/master/bolgs/BlogImage")),
);
const BlogComments = Loadable(
  lazy(() => import("../../pages/admin/master/bolgs/BlogComments")),
);

const Transaction = Loadable(
  lazy(() => import("../../pages/admin/transaction/Transaction")),
);

const BankReport = Loadable(
  lazy(() => import("../../pages/admin/bankReport/BankReport")),
);

const Courses = Loadable(lazy(() => import("../../pages/admin/master/course")));
const AddCourse = Loadable(
  lazy(() => import("../../pages/admin/master/course/AddCourse")),
);
const EditCourse = Loadable(
  lazy(() => import("../../pages/admin/master/course/EditCourse")),
);
const ReorderCourse = Loadable(
  lazy(() => import("../../pages/admin/master/course/ReorderCourse")),
);

const Services = Loadable(
  lazy(() => import("../../pages/admin/master/services")),
);
const AddService = Loadable(
  lazy(() => import("../../pages/admin/master/services/AddService")),
);
const EditService = Loadable(
  lazy(() => import("../../pages/admin/master/services/EditService")),
);
const ReorderServices = Loadable(
  lazy(() => import("../../pages/admin/master/services/ReorderService")),
);

const Category = Loadable(
  lazy(() => import("../../pages/admin/master/category")),
);
const Enquiries = Loadable(
  lazy(() => import("../../pages/admin/enquiry/enquiries")),
);
const MentorEnquiries = Loadable(
  lazy(() => import("../../pages/admin/enquiry/mentorEnquiry")),
);
const Quotation = Loadable(
  lazy(() => import("../../pages/admin/enquiry/quotation")),
);
const Faqs = Loadable(lazy(() => import("../../pages/admin/faqs")));
const FeeManagement = Loadable(
  lazy(() => import("../../pages/admin/master/fee")),
);
const Testimonial = Loadable(
  lazy(() => import("../../pages/admin/testimonial")),
);
const Roles = Loadable(lazy(() => import("../../pages/admin/users/roles")));
const User = Loadable(lazy(() => import("../../pages/admin/users/user")));

const MonthlyReport = Loadable(
  lazy(() => import("../../pages/admin/users/report")),
);

const EditUser = Loadable(
  lazy(() => import("../../pages/admin/users/user/EditUser")),
);
const AddUser = Loadable(
  lazy(() => import("../../pages/admin/users/user/AddUser")),
);

const Plan = Loadable(lazy(() => import("../../pages/admin/master/plan")));

const UserCourse = Loadable(
  lazy(() => import("../../pages/admin/master/plan/UserCourse")),
);

const ReceiptRender = Loadable(lazy(() => import("../../pdf/receipt/index")));

const AddPlan = Loadable(
  lazy(() => import("../../pages/admin/master/plan/AddPlan")),
);

const PortalSettings = Loadable(
  lazy(() => import("../../pages/admin/setting/headerSetting")),
);

export default [
  {
    path: "categories",
    children: [
      {
        path: "",
        element: <Category />,
      },
      {
        path: ":ID",
        element: <Category />,
      },
    ],
  },
  {
    path: "fee",
    element: <FeeManagement />,
  }, {
    path: "configure-portal",
    element: <PortalSettings />,
  },
  {
    path: "setting",
    children: [
      {
        path: "header",
        element: <PortalSettings />,
      },
       {
        path: "footer",
        element: <FooterSetting />,
      },
      {
        path: "banner",
        element: <BannerSliderSetting />,
      },
    ],
  },
  {
    path: "plan",
    children: [
      {
        path: "",
        element: <Plan />,
      },
      {
        path: "course/:ID",
        element: <UserCourse />,
      },
      {
        path: "bill/:ID/:ReceiptType",
        element: <ReceiptRender />,
      },
      {
        path: "add",
        element: <AddPlan />,
      },
    ],
  },
  {
    path: "course",
    children: [
      {
        path: "",
        element: <Courses />,
      },
      {
        path: "add",
        element: <AddCourse />,
      },
      {
        path: "edit/:ID",
        element: <EditCourse />,
      },
      {
        path: "reorder",
        element: <ReorderCourse />,
      },
    ],
  },
  {
    path: "blogs",
    children: [
      {
        path: "",
        element: <Blogs />,
      },
      {
        path: "add",
        element: <AddBlogs />,
      },
      {
        path: "edit/:ID",
        element: <EditBlogs />,
      },
      {
        path: "image/:ID",
        element: <BlogsImage />,
      },
      {
        path: "comments/:ID",
        element: <BlogComments />,
      },
      {
        path: "reorder",
        element: <ReorderBlogs />,
      },
    ],
  },
  {
    path: "services",
    children: [
      {
        path: "",
        element: <Services />,
      },
      {
        path: "add",
        element: <AddService />,
      },
      {
        path: "edit/:ID",
        element: <EditService />,
      },
      {
        path: "reorder",
        element: <ReorderServices />,
      },
    ],
  },
  {
    path: "enquiries",
    element: <Enquiries />,
  },
  {
    path: "mentor-enquiries",
    element: <MentorEnquiries />,
  },
  {
    path: "quoatation",
    element: <Quotation />,
  },
  {
    path: "faq",
    element: <Faqs />,
  },
  {
    path: "testimonial",
    element: <Testimonial />,
  },
  {
    path: "users",
    children: [
      {
        path: "",
        element: <User />,
      },
      {
        path: "add",
        element: <AddUser />,
      },
      {
        path: "edit/:ID",
        element: <EditUser />,
      },
      {
        path: "roles",
        element: <Roles />,
      },
      {
        path: "monthly-report",
        element: <MonthlyReport />,
      },
      {
        path: "course/:ID",
        element: <UserCourse user={true} />,
      },

      {
        path: "mentor/:ID",
        element: <Mentor />,
      },
    ],
  },
  {
    path: "transaction",
    children: [
      { path: "", element: <Transaction /> },
      {
        path: "plan/:PlanId",
        element: <Transaction />,
      },
    ],
  },
  {
    path: "bank-report",
    element: <BankReport />,
  },
];
